import Phaser from 'phaser';

const BG_OUTER = 0x3f0a18;
const BG_INNER = 0x7f1d1d;
const HEX_DARK = 0xb91c1c;
const HEX_MID = 0xef4444;
const HEX_LIGHT = 0xfca5a5;
const SPARKLE = 0xfee2e2;
const STROKE = 0x0a0f1f;

export function drawHex(g: Phaser.GameObjects.Graphics, size: number) {
  g.clear();
  const pad = Math.max(4, Math.floor(size * 0.08));
  const r = (size - pad * 2) / 2;
  const stroke = Math.max(3, Math.floor(size * 0.06));

  g.lineStyle(stroke, STROKE, 1);
  g.fillStyle(BG_OUTER, 1);
  g.fillCircle(0, 0, r);
  g.strokeCircle(0, 0, r);

  g.fillStyle(BG_INNER, 1);
  g.fillCircle(0, 0, r * 0.88);

  const crescentR = r * 0.58;
  const offset = r * 0.22;

  g.fillStyle(HEX_DARK, 1);
  g.fillCircle(-offset, 0, crescentR);
  g.fillStyle(BG_INNER, 1);
  g.fillCircle(-offset + crescentR * 0.5, 0, crescentR * 0.85);

  g.fillStyle(HEX_DARK, 1);
  g.fillCircle(offset, 0, crescentR);
  g.fillStyle(BG_INNER, 1);
  g.fillCircle(offset - crescentR * 0.5, 0, crescentR * 0.85);

  g.fillStyle(HEX_MID, 1);
  g.fillCircle(-offset + crescentR * 0.25, 0, crescentR * 0.45);
  g.fillCircle(offset - crescentR * 0.25, 0, crescentR * 0.45);

  g.fillStyle(HEX_LIGHT, 0.7);
  g.fillCircle(0, 0, r * 0.15);
  g.fillStyle(SPARKLE, 1);
  g.fillCircle(0, 0, r * 0.06);

  g.lineStyle(Math.max(1, Math.floor(stroke * 0.7)), STROKE, 1);
  g.strokeCircle(-offset, 0, crescentR);
  g.strokeCircle(offset, 0, crescentR);
}
